<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
import VuePlotly from '@statnett/vue-plotly';
import {mapGetters} from 'vuex';
import {config} from '@/store/config';

export default {
  name: 'hist_impexpgraph_tm_total_mp1c',
  components: {
    VuePlotly,
  },
  props: [],
  computed: {
    ...mapGetters([
      'get_dsm_result',
      'historyPlotDataTotal',
      'getDsmAppState',
      'app_data',
      'single_product',
      'home_market_code',
    ]),
    plotData: function() {
      let plot_list = [
        {
          y: this.export_share_values(),
          x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            'dsm_history_total_world_sum'
          ].map(v => v['T_Year']),
          type: 'bar',
          marker: {
            color: [
              config.plot_grey,
              config.plot_grey,
              config.plot_grey,
              config.plot_grey,
              config.plot_grey,
            ],
          },
        },
      ];

      return plot_list;
    },
    show: function() {
      // return this.$store.getters.historyPlotDataTotal['x'][0] > 1 ? true : false;
      return true;
    },
    layout: function() {
      return {
        title: {
          automargin: true,
          text: `${this.codeToMarket(
            this.home_market_code,
          )} share of REOs imports into <br>${this.codeToMarket(
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .markets.C_Code[0],
          )}`,
          font: {
            size: 10,
            color: 'black',
          },
          yref: 'container',
          x: 0.5,
          y: 0.94,
          yanchor: 'bottom',
          pad: {
            b: 10,
          },
        },
        ...config.mp1c_layouts_bars,

        xaxis: {
          tickmode: 'linear',
          tickfont: {
            size: 10,
          },
        },
        yaxis: {
          title: '',
          rangemode: 'tozero',
          tickfont: {
            size: 10,
          },
        },
        legend: {
          orientation: 'h',
          font: {size: 9},
          automargin: true,
        },
        annotations: [
          {
            x: '-0.06',
            y: '1.15',
            xref: 'paper',
            yref: 'paper',
            xanchor: 'left',
            yanchor: 'top',
            text: '%',
            showarrow: false,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 0.39,
            y: -0.1,
            xanchor: 'center',
            yanchor: 'top',
            text: config.CEPII_Source,
            showarrow: false,
            font: {
              family: 'Arial',
              size: 8,
              color: 'rgb(150,150,150)',
            },
          },
        ],
      };
    },
  },
  methods: {
    export_share_values() {
      // let Total_HM_ExportVal = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
      //   'dsm_history_total_world_sum'
      // ].reduce((sum, v) => sum + v['HM_ExportVal'], 0);

      let exports = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
        'dsm_history_total_world_sum'
      ].map(v => (v['HM_ExportVal'] / v['TM_ImportVal']) * 100);

      return exports;
    },
  },
  data: function() {
    return {
      options: {
        responsive: true,
        displayModeBar: false,
      },
    };
  },
};
</script>
